import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider } from './shared/theme/ThemeProvider';
import { AuthProvider } from './shared/auth/AuthProvider';
import { ToastProvider } from './shared/components';
import { AppSection } from './layouts/AppSection';
import { ApplicationSelectorPage } from './modules/app-selector/ApplicationSelectorPage';
import { ControlOperativoRoutes } from './router/routes';
import { GestionHumanaRoutes } from './router/hrRoutes';
import { TurnoGeoRoutes } from './router/turnoGeoRoutes';
import { PingWatcher } from './modules/turno-geo/components/PingWatcher';
import { getVisibleHrModules } from './shared/config/hrModules';
import { getVisibleTurnoGeoModules } from './shared/config/turnoGeoModules';

/**
 * LCC ya no es una sola aplicacion: es una plataforma con un Selector de
 * Aplicacion como entrada (ver ApplicationSelectorPage), y una rama de router
 * por cada aplicacion de la Suite. Cada rama esta envuelta en <AppSection>,
 * que fija cual aplicacion esta activa (header X-Lcc-Application, fijado
 * SINCRONAMENTE - ver shared/auth/ApplicationContext.tsx) y resuelve el
 * Rol/Pantallas del usuario PARA ESA aplicacion puntual (CurrentUserProvider
 * ya NO vive aqui arriba - ver shared/auth/AuthProvider.tsx).
 *
 * Nota: ApplicationProvider (el que fija la app activa) NO se monta aqui a
 * nivel global - cada <AppSection> lo monta con SU codigo de aplicacion. El
 * Selector de Aplicacion vive fuera de cualquier AppSection, sin aplicacion
 * activa todavia.
 *
 * Agregar una aplicacion nueva a la Suite: (1) su rama <Route element={...}>
 * aqui, (2) su router en /router, (3) su carpeta en /modules - ninguna
 * aplicacion existente se modifica en el proceso.
 */
export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<ApplicationSelectorPage />} />

              <Route element={<ControlOperativoLayout />}>
                {ControlOperativoRoutes()}
              </Route>

              <Route element={<GestionHumanaLayout />}>
                {GestionHumanaRoutes()}
              </Route>

              <Route element={<TurnoGeoLayout />}>
                {TurnoGeoRoutes()}
              </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

function ControlOperativoLayout() {
  return (
    <AppSection applicationCode="control-operativo">
      <Outlet />
    </AppSection>
  );
}

function GestionHumanaLayout() {
  return (
    <AppSection applicationCode="gestion-humana" getVisibleModules={getVisibleHrModules}>
      <Outlet />
    </AppSection>
  );
}

function TurnoGeoLayout() {
  return (
    <AppSection applicationCode="turno-geo" getVisibleModules={getVisibleTurnoGeoModules}>
      <PingWatcher />
      <Outlet />
    </AppSection>
  );
}
